import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'expo-router'
import { Platform } from 'react-native'

import { unregisterAllServiceWorkers } from '@/src/general/service-worker/registerServiceWorker'
import { fetcher } from '@/src/general/utilities/fetcher'
import { storage } from '@/src/general/utilities/storage'
import { Cookie } from '@/src/general/utils/cookies/Cookie'

import { authApi } from '../api/authApi'
import type { TCredentials } from '../models/auth.types'
import { authTokenStorage } from '../utils/authTokenStorage'

export const useAuthentication = () => {
  const router = useRouter()

  const { mutateAsync: login, error: loginError } = useMutation({
    mutationFn: async (credentials: TCredentials) => authApi.postLogin(credentials),
    onSuccess: ({ token }) => {
      fetcher.setXAuthToken(token)
      authTokenStorage.setToken(token)
    },
  })

  const logout = (redirect?: boolean) => {
    storage.clear()
    authTokenStorage.removeToken()
    fetcher.removeXAuthToken()
    Cookie.clearAll()
    unregisterAllServiceWorkers()
    if (redirect ?? true) {
      router.replace('/')
    }
  }

  const { mutateAsync: deleteAccount } = useMutation({
    mutationFn: async () => authApi.deleteAccount(),
    onSuccess: () => {
      storage.clear()
      authTokenStorage.removeToken()
      fetcher.removeXAuthToken()
      if (Platform.OS === 'web') Cookie.clearAll()
    },
  })

  return {
    login,
    loginError,
    logout,
    deleteAccount,
  }
}
